import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { ApplicationStateService } from '../services/application-state.service';


@Injectable({
  providedIn:'root'
})
export class StepperRouteGuard implements CanActivate {

    constructor(private router: Router, applicationState: ApplicationStateService) {
      this.applicationState = applicationState;
    }

    private applicationState: ApplicationStateService;

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // check if current step matches URL
        if (this.applicationState.currentStep === route.data.stepName) {
          return true;
        }

        this.router.navigateByUrl('/error');
        return false;
    }

}
